import { Controller } from "@hotwired/stimulus"

// 一定時間後に自分自身を DOM から取り除く。自動保存の「保存済み ✓」表示に使う。
// data-fade-out-delay-value でミリ秒を上書きできる（既定 2000）。
//
// 使い方(view): <span data-controller="fade-out">保存済み ✓</span>
const FADE_MS = 300

export default class extends Controller {
  static values = { delay: { type: Number, default: 2000 } }

  connect() {
    this.timer = setTimeout(() => {
      this.element.classList.add("transition-opacity", "duration-300", "opacity-0")
      this.fadeTimer = setTimeout(() => this.element.remove(), FADE_MS)
    }, this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timer)
    clearTimeout(this.fadeTimer)
  }
}
